import { Component, Input } from '@angular/core';
import { SlimTicket, TicketState } from '@proto/hubspotr';
import { SupportV2Service } from '../supportv2.service';

@Component({
  selector: 'app-ticket-card-v2',
  templateUrl: './ticket-card-v2.component.html',
  standalone: false
})
export class TicketCardV2Component {

  @Input()
  public ticket: SlimTicket;

  @Input()
  public applianceId: string;

  constructor(public supportService: SupportV2Service) {}

  get ticketStateClass() {
    return {
      'unknown': this.ticket.state === TicketState.STATE_UNKNOWN,                 // 0
      'new': this.ticket.state === TicketState.STATE_NEW,                         // 1
      'wait-on-contact': this.ticket.state === TicketState.STATE_WAIT_ON_CONTACT, // 2
      'wait-on-us': this.ticket.state === TicketState.STATE_WAIT_ON_US,           // 3
      'wait-on-dev': this.ticket.state === TicketState.STATE_WAIT_ON_DEV,         // 4
      'closed': this.ticket.state === TicketState.STATE_CLOSED,                   // 5
      'wait-on-appointment': this.ticket.state === TicketState.STATE_WAIT_ON_APPOINTMENT, // 6
      'wait-on-close': this.ticket.state === TicketState.STATE_WAIT_ON_CLOSE,     // 7
      'unrecognized': this.ticket.state === TicketState.UNRECOGNIZED              // -1
    };
  }
}
